const listVariants = {
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.15,
    },
  },
  hidden: {
    opacity: 0,
  },
};

const buttonVariants = {
  visible: {
    opacity: 1,
    x: 0,
  },
  hidden: {
    opacity: 0,
    x: -25,
  },
};

export function listProps(key: string) {
  return {
    variants: listVariants,
    initial: 'hidden',
    animate: 'visible',
    key: `list-${key}`,
  };
}

export function buttonProps(key: string) {
  return {
    variants: buttonVariants,
    key,
  };
}
